/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { CSpinner } from '@coreui/react-pro'
import React from 'react'
import loadingSpinner from '../../assets/images/loading-spinner/ajax-loader.gif'
import {
  LoadingSpinner,
  LoadingType,
} from '../../types/Components/loadingScreenTypes'

const OLoadingSpinner = (props: LoadingSpinner): JSX.Element => {
  return (
    <>
      <div className="loading-spinner-backdrop ">
        <div className="loading-spinner" data-testid="loading-spinner">
          {props.type === LoadingType.COMPONENT ? (
            <CSpinner color="primary" />
          ) : (
            <img src={loadingSpinner} alt="Loading..." />
          )}
        </div>
      </div>
    </>
  )
}

export default OLoadingSpinner
